import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------


// GET =>  get All Materials
export const getAllMaterials = createAsyncThunk(
    "material/getAllMaterials",
    async (data, thunkAPI) => {
        try {
            const response = await axios.get(URLS.getAllMaterialsURL);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

// POST =>  addMaterial
export const addMaterial = createAsyncThunk(
    "material/addMaterial",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(URLS.addMaterialURL, data);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// DELTE =>  delete Material
export const deleteMaterial = createAsyncThunk(
    "material/deleteMaterial",
    async (id, thunkAPI) => {
        try {
            const response = await axios.delete(`${URLS.deleteMaterialURL}/${id}`);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// POST =>  add Material to Class
export const addMaterialsToClass = createAsyncThunk(
    "material/addMaterialsToClass",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(URLS.addMaterialsToClassURL, data);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// GET =>  get MaterialsForClass
export const getMaterialsForClass = createAsyncThunk(
    "material/getMaterialsForClass",
    async (params, thunkAPI) => {
        try {
            const response = await axios.get(
                `${URLS.getMaterialsForClassURL}/${params.school_id}/${params.class_id}`
            );
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);